import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteSendAtom = createMutationAtomFactory(
  'brokerage.quoteSend',
  (params: { id: string }) => ({
    tradeQuoteSend: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
